module.exports = __webpack_public_path__ + "static/media/cliente-novamerica.3ffdf2cd.webp";